import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

interface CompoundFamilyComboBoxProps {
  value: string;
  options: string[];
  onChange: (value: string) => void;
  disabled?: boolean;
}

/**
 * CompoundFamilyComboBox — Dropdown for selecting the rubber compound family.
 * Options are driven by the bushing-type config (not hardcoded here).
 */
const CompoundFamilyComboBox: React.FC<CompoundFamilyComboBoxProps> = ({
  value,
  options,
  onChange,
  disabled = false,
}) => (
  <Autocomplete
    value={options.includes(value) ? value : options[0] ?? ''}
    options={options}
    onChange={(_e, newVal) => {
      if (newVal) onChange(newVal);
    }}
    disableClearable
    size="small"
    disabled={disabled}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Compound family"
        variant="outlined"
      />
    )}
    sx={{ width: '100%' }}
  />
);

export default React.memo(CompoundFamilyComboBox);
